import React, { useEffect } from 'react';
import { useHandleSuccessfulLogin } from '../../Hooks/useHandleSuccessfulLogin';

const OauthLogin = ({activityLogId, redirectTo}) => {
  const { redirectOnLogin, manageCookies } = useHandleSuccessfulLogin();

  useEffect(() => {
    handleOauthLogin();
    if (redirectTo) {
      sessionStorage.setItem('redirect-url', redirectTo);
    }
  }, []);

  const handleOauthLogin = () => {
    let data = {};
    if (sessionStorage.getItem('sp_initiated_sso') == 'true') {
      data = { activity_log_id: activityLogId };
      sessionStorage.removeItem('sp_initiated_sso');
    }
    $.ajax({
      method: 'POST',
      url: '/auth/authentication_token',
      data,
      success: (response, _, jqXHR) => {
        if (response.success){
          manageCookies(response);
          redirectOnLogin(response);
        }
      },
      error: (err) => {
        toastr.error(JSON.parse(err.responseText).message)
      }
    });
  };

  return null;
};

export default OauthLogin;
